import { handleActions, createAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';

export const activateEmail = createAction('ACTIVATE_EMAIL', (email) => {
  return getDataProvider().register(email);
});

export default handleActions({
  [`${activateEmail}_PENDING`]: (state, action) => {
    return { pending: true, done: false, error: null };
  },
  [`${activateEmail}_FULFILLED`]: (state, action) => {
    return { pending: false, done: true, error: null };
  },
  [`${activateEmail}_REJECTED`]: (state, action) => {
    return { pending: false, done: true, error: action.payload };
  }
}, { pending: false, done: false, error: null });
